export default __webpack_public_path__ + "static/media/increase.544b8e50.svg";